import $ from 'jquery';

const namespace = 'filtergroup';

export default class FilterGroup {
  state = {
    selected: 0,
    vals: [],
  };

  constructor(el, options) {
    this.$el = $(el);
    this.el = this.$el.get(0);

    this.options = $.extend(
      true,
      {
        selectors: {
          option: '.filters__option',
          drop: '.filters__drop',
        },
        classes: {
          selected: 'is-selected',
          active: 'is-active',
        },
      },
      {
        ...this.el.dataset,
      },
      options,
    );

    this.$drop = this.$el.find(this.options.selectors.drop);
    this.$options = this.$el.find(this.options.selectors.option);

    this.bind();
    this.update();
  }

  get valueOptions() {
    return this.$options.map((_, item) => item.value).toArray();
  }

  get vals() {
    return this.state.vals;
  }

  /**
   * @param {Array} values
   */
  set vals(values) {
    this.state.vals = values;
    this.selected = values.length;
  }

  get selected() {
    return this.state.selected;
  }

  /**
   * @param {Number} count
   */
  set selected(count) {
    this.state.selected = count;
  }

  get name() {
    return this.options.groupname;
  }

  bind() {
    this.$el.on(
      `change.option.${namespace}`,
      this.options.selectors.option,
      this.handleChange.bind(this),
    );
  }

  clear() {
    this.$options.prop('checked', false);

    this.update();
    this.$el.trigger(`${namespace}:cleared`);
  }

  handleChange() {
    this.update();
    this.$el.trigger(`${namespace}:changed`);
  }

  update() {
    this.state.vals = this.getSelected();
    this.state.selected = this.state.vals.length;
  }

  getSelected() {
    return this.$options
      .filter((_, item) => $(item).is(':checked'))
      .map((_, item) => item.value)
      .get();
  }

  /**
   * @param {Array} values
   */
  disableOptions(values) {
    this.$options.each((_, opt) => {
      if (values.includes(opt.value)) {
        opt.disabled = true;
      } else {
        opt.disabled = false;
      }
    });
  }

  /**
   * @param {Array} values
   */
  setSelected(values) {
    this.vals = values;
    this.$options.each((_, opt) => {
      if (values.includes(opt.value)) {
        opt.checked = true;
      } else {
        opt.checked = false;
      }
    });
  }
}
